import $ from 'jquery';

export const getSessionId = () => {
    const sessionId = $('meta[name=sessionId]').attr("content");

    return sessionId ? sessionId : null;
};
